import { Component, Inject, Injector, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from 'src/app/shared/common-data-model';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-orders-view-notes-form',
  templateUrl: './orders-view-notes-form.component.html',
  styleUrls: ['./orders-view-notes-form.component.scss']
})
export class OrdersViewNotesFormComponent extends AppComponentBase implements OnInit {

  @ViewChild('grid', { static: true }) private grid: GridComponent;
  @ViewChild('orderViewNoteForm', { static: true }) orderViewNoteForm: NgForm;

  gridItems: any;
  ordersDataModel = new CommonDataModel();
  orderViewNoteModel: any;
  isFormLoading = false;
  actionData: any;
  isJob: any;
  notes: any;

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<OrdersViewNotesFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(injector);
    this.isJob = (this.router.url.indexOf('/quotes-list') !== -1) ? false : true;
    this.actionData = data;
    if (this.actionData.dataItem.orderId) {
      this.actionData.dataItem.jobId = this.actionData.dataItem.orderId;
    }
  }

  ngOnInit() {
    this.onRefreshGridData();
  }

  onRefreshGridData(): void {
    this.kendogridHelper.sort = [{ dir: 'desc', field: 'createdDate' }];
    this.grid.dataStateChange.emit({
      skip: 0,
      take: 5,
      filter: undefined,
      group: undefined,
      sort: this.kendogridHelper.sort,
    });
  }

  getGridRecords(event: DataStateChangeEvent): void {
    if (event) {
      this.kendogridHelper.dataStateChangeEvent(event);
    }
    this.kendogridHelper.showLoadingIndicator();
    const queryParams = `OrderId=${this.actionData.dataItem.jobId}`;
    this.commonService.gerOrderNotes(queryParams)
      .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe((response: any) => {
        if (response.isSuccess) {
          this.gridItems = response.data;
          this.kendogridHelper.setGridData(this.gridItems);
        } else {
          this.toastr.error(response.errors || 'Something Went wrong, Please Re-try.', 'Error!');
        }
        this.kendogridHelper.hideLoadingIndicator();
      });
  }


  onSubmit() {
    const requestBody = {
      orderId: this.actionData.dataItem.jobId,
      notes: this.notes
    };
    this.isFormLoading = true;
    this.commonService.createOrderNote(requestBody)
      .pipe(finalize(() => (this.isFormLoading = false)))
      .subscribe(response => {
        this.isFormLoading = false;
        this.notes = '';
        this.orderViewNoteForm.onReset();
        this.onRefreshGridData();
        if (response.isSuccess) {
          this.toastr.success('Notes Added Successfully');
        } else {
          this.toastr.error(response.errors || 'Something went wrong please Re-try.', 'Error!');
        }
      });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
